import { render, staticRenderFns } from "./PenjualanLelang.vue?vue&type=template&id=24029aab&"
import script from "./PenjualanLelang.vue?vue&type=script&lang=js&"
export * from "./PenjualanLelang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports